import { render, staticRenderFns } from "./PazarAsnaf.vue?vue&type=template&id=fc900964"
import script from "./PazarAsnaf.vue?vue&type=script&lang=js"
export * from "./PazarAsnaf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports